import { render, staticRenderFns } from "./ExameneIndex.vue?vue&type=template&id=0de123ce&"
import script from "./ExameneIndex.vue?vue&type=script&lang=js&"
export * from "./ExameneIndex.vue?vue&type=script&lang=js&"
import style0 from "./ExameneIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports